module.exports = __webpack_public_path__ + "static/documents-tablet-ff97a63631959e6f92ede8dfd586994a.png";